import React, { useState, useEffect } from "react";
import {
   Popconfirm,
   Empty,
   Button,
   Menu,
   Dropdown,
   message,
   Tabs,
   Row,
   Col
} from "antd";
import {
   SearchOutlined,
   EllipsisOutlined,
   DeleteOutlined,
   LoadingOutlined,
   PlayCircleOutlined,
   PauseCircleOutlined
} from "@ant-design/icons";
import axios from "axios";
import useAxios from "axios-hooks";
import { Auth } from "aws-amplify";
import { useTranslation } from "react-i18next";
import { PassportDetail } from "../Details/Drawer/PassportDetail";
import { AddDemand } from "../Details/Drawer/AddDemand";
import { Resource } from "../../../../api/common";
import { Matches } from "./Drawer/Matches";
import { SourcingRequestDetails } from "./Drawer/SourcingRequestDetails";
import { SellingRequestDetails } from "./Drawer/SellingRequestDetails";
import { RequestComments } from "./Drawer/RequestComments";
import { useAuth } from "../../../../contexts/auth/index";
import { OrderDetailsModal } from "./OrderDetailsModal";

const { TabPane } = Tabs;

export const Materials = ({
   showDrawer,
   dataSelectedMaterials,
   fetchMaterials,
   refetchSelectedMaterials,
   tabKey,
   callbackInnerTab,
   showDrawerLoading
}: any) => {
   const [selectedMaterials, setSelectedMaterials] = useState<any>([]);
   const [sellingStatus, setSellingStatus] = useState<number>(0);
   const [manageSellingLoading, setManageSellingLoading] =
      useState<boolean>(false);
   const [t] = useTranslation();
   const [showAddDemand, setShowAddDemand] = useState<boolean>(false);
   const [allDemandsList, setAllDemandsList] = useState<any>([]);
   const [showMatches, setShowMatches] = useState<boolean>(false);
   const [selectedMatch, setSelectedMatch] = useState<any>();
   const { user: currentUser } = useAuth();
   const isPrivateOwner =
      currentUser &&
      currentUser["attributes"] &&
      currentUser["attributes"]["custom:user_type"] === "private-owner";

   const [{ data: dataDemands, loading: getDemandsLoading }, getAllDemands] =
      useAxios(
         {
            url: `${Resource.path.demandApiUrlHub()}`,
            method: "GET"
         },
         { useCache: false }
      );

   useEffect(() => {
      if (dataSelectedMaterials?.data) {
         setSelectedMaterials(dataSelectedMaterials.data);
      }
      if (dataDemands?.data) {
         setAllDemandsList(dataDemands.data);
      }
   }, [dataSelectedMaterials, dataDemands]);

   const addDemand = () => {
      setShowAddDemand(true);
   };

   const Passport = (props: any) => {
      const { selectedMat } = props;
      const [passportSpecification, setPassportSpecification] = useState<any>();
      const [showPassportDetail, setShowPassportDetail] =
         useState<boolean>(false);
      const { id, selling_started } = selectedMat;
      const [requestData, setRequestData] = useState<any>([]);
      const [selectedRequest, setSelectedRequest] = useState<any>({});
      const [showRequestDetails, setShowRequestDetails] =
         useState<boolean>(false);

      const [{ loading: deleteLoading }, removePassport] = useAxios(
         {
            url: `${Resource.path.operationsHub}/selling/remove/${id}`,
            method: "DELETE"
         },
         { manual: true }
      );

      const [{ data: getRequestData }, fetchRequestDetails] = useAxios(
         {
            url: `${Resource.path.getSellingRequestDataHub(id)}`,
            method: "GET"
         },
         { manual: false }
      );

      const showDetailPage = (material: any) => {
         setPassportSpecification(material);
         setShowPassportDetail(true);
      };

      const onCloseDetail = () => {
         setShowPassportDetail(false);
      };

      const confirmDelete = async () => {
         await removePassport()
            .then(() => {
               fetchMaterials();
               refetchSelectedMaterials();
            })
            .catch((error) => {
               console.log(error);
               message.error(t("buildingOperations.errorMessage"));
            });
      };

      const onCloseRequestDetails = () => {
         setSelectedRequest({});
         setShowRequestDetails(!showRequestDetails);
      };

      useEffect(() => {
         if (getRequestData?.data) {
            setRequestData(getRequestData.data);
         }
      }, [getRequestData]);

      const MatchedData = (props: any) => {
         const { data, setSelectedRequest, getRequestDetails } = props;
         const [requestStatus, setRequestStatus] = useState(data.status);
         const [requestPaid] = useState(data.paid);
         const [showRequestComments, setShowRequestComments] = useState(false);

         const [{ loading: updateRequestLoading }, updateRequestStatus] =
            useAxios(
               {
                  url: `${Resource.path.updateRequestHub(
                     data.id,
                     data.requests_id
                  )}`,
                  method: "POST"
               },
               { manual: true }
            );

         const updateRequest = async (status: any) => {
            await updateRequestStatus({
               data: {
                  status,
                  comment: "",
                  action_by: "SELLING"
               }
            })
               .then(() => {
                  setRequestStatus(status);
               })
               .catch((error) => {
                  console.log(error);
               });
         };

         if (updateRequestLoading) {
            (window as any).NProgress.start();
         } else {
            (window as any).NProgress.done();
         }

         return (
            <>
               <div className="request inner seller">
                  <div className="matching-state">
                     <figure className="demanded">
                        {data?.images && (
                           <img src={data?.images[0]?.object_url} />
                        )}
                        {!data?.images && (
                           <img src="data:image/png;base64,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" />
                        )}
                     </figure>
                  </div>
                  <div className="item-name">
                     <strong>{data.product_name}</strong>
                     <span className="amount">
                        {data.requests_amount} {data.amount_unit}
                     </span>
                     {selectedMat?.max_selling_price &&
                        selectedMat?.min_selling_price &&
                        selectedMat?.max_selling_price !==
                           selectedMat?.min_selling_price && (
                           <span className="amount">
                              {selectedMat.min_selling_price} -{" "}
                              {selectedMat?.max_selling_price}{" "}
                              <b>€/{selectedMat.amount_unit_op}</b>
                           </span>
                        )}
                     {selectedMat?.max_selling_price &&
                        selectedMat?.min_selling_price &&
                        selectedMat?.max_selling_price ===
                           selectedMat?.min_selling_price && (
                           <span className="amount">
                              {selectedMat.min_selling_price}{" "}
                              <b>€/{selectedMat.amount_unit_op}</b>
                           </span>
                        )}
                  </div>
                  {requestStatus === "REQUESTED" && (
                     <div className="status">
                        <small>Status</small>
                        <div className="current">
                           <span
                              className={`tag payment ${
                                 requestPaid == 1 ? "paid" : "pending"
                              }`}
                           >
                              {data.proposal_price} €/{data.amount_unit}
                           </span>
                           <span className="tag">angefragt</span>
                        </div>
                        <div className="progress">
                           <div
                              className={`progress-bar  ${requestStatus.toLowerCase()}`}
                           ></div>
                        </div>
                     </div>
                  )}
                  {requestStatus === "ACCEPTED" && !isPrivateOwner && (
                     <div className="status">
                        <small>Status</small>
                        <div className="current">
                           <span
                              className={`tag payment ${
                                 requestPaid == 1 ? "paid" : "pending"
                              }`}
                           >
                              {data.proposal_price} €/{data.amount_unit}
                           </span>
                           <span className="tag">angenommen</span>{" "}
                           {!isPrivateOwner && <span>Wird bearbeitet ...</span>}
                        </div>
                        <div className="progress">
                           <div
                              className={`progress-bar  ${requestStatus.toLowerCase()}`}
                           ></div>
                        </div>
                     </div>
                  )}
                  {requestStatus !== "ACCEPTED" &&
                     requestStatus !== "REQUESTED" &&
                     !isPrivateOwner && (
                        <div className="status">
                           <small>Status</small>
                           <div className="current">
                              <span
                                 className={`tag payment ${
                                    requestPaid == 1 ? "paid" : "pending"
                                 }`}
                              >
                                 {data.proposal_price} €/{data.amount_unit}
                              </span>
                              <span className="tag">
                                 {requestStatus.toLowerCase()}
                              </span>{" "}
                              {data?.hubspot_data?.properties
                                 ?.seller_update && (
                                 <span>
                                    {
                                       data.hubspot_data.properties
                                          .seller_update.value
                                    }
                                 </span>
                              )}
                           </div>
                           <div className="progress">
                              <div
                                 className={`progress-bar  ${requestStatus.toLowerCase()}`}
                              ></div>
                           </div>
                        </div>
                     )}
                  {requestStatus !== "ACCEPTED" &&
                     requestStatus !== "REQUESTED" &&
                     !!isPrivateOwner && (
                        <div className="status">
                           <small>Status</small>
                           <div className="current">
                              <span
                                 className={`tag payment ${
                                    requestPaid == 1 ? "paid" : "pending"
                                 }`}
                              >
                                 {data.proposal_price} €/{data.amount_unit}
                              </span>
                              <span className="tag">
                                 {requestStatus.toLowerCase()}
                              </span>
                           </div>
                           <div className="progress">
                              <div
                                 className={`progress-bar  ${requestStatus.toLowerCase()}`}
                              ></div>
                           </div>
                        </div>
                     )}
                  {requestStatus === "REQUESTED" && (
                     <div className="actions">
                        <div className="order">
                           {!isPrivateOwner && (
                              <Button
                                 type="primary"
                                 onClick={() => {
                                    updateRequest("ACCEPTED");
                                 }}
                              >
                                 Anfrage akzeptieren
                              </Button>
                           )}
                           {!!isPrivateOwner && (
                              <Button
                                 type="primary"
                                 onClick={() => {
                                    updateRequest("IN-PROGRESS");
                                 }}
                              >
                                 Anfrage akzeptieren
                              </Button>
                           )}
                        </div>
                        <Button
                           type="default"
                           onClick={() => {
                              setSelectedRequest(data);
                           }}
                        >
                           Details
                        </Button>
                        {!!isPrivateOwner && (
                           <Button
                              type="default"
                              onClick={() => {
                                 setShowRequestComments(true);
                              }}
                           >
                              Chat
                           </Button>
                        )}
                     </div>
                  )}
                  {requestStatus !== "ACCEPTED" &&
                     requestStatus !== "REQUESTED" &&
                     !isPrivateOwner && (
                        <div className="actions">
                           {requestStatus !== "DELIVERED" &&
                              requestStatus !== "DECLINED" &&
                              requestStatus !== "FAILED" && (
                                 <div className="order">
                                    <Button
                                       type="primary"
                                       onClick={() => {
                                          updateRequest("DECLINED");
                                       }}
                                    >
                                       Stornieren
                                    </Button>
                                 </div>
                              )}
                           <Button
                              type="default"
                              onClick={() => {
                                 setSelectedRequest(data);
                              }}
                           >
                              Details
                           </Button>
                           {!!isPrivateOwner && (
                              <Button
                                 type="default"
                                 onClick={() => {
                                    setShowRequestComments(true);
                                 }}
                              >
                                 Chat
                              </Button>
                           )}
                        </div>
                     )}
                  {requestStatus !== "ACCEPTED" &&
                     requestStatus !== "REQUESTED" &&
                     !!isPrivateOwner && (
                        <div className="actions">
                           {requestStatus !== "DECLINED" &&
                              requestStatus !== "FAILED" &&
                              requestStatus !== "DELIVERED" && (
                                 <div className="order">
                                    <Button
                                       type="primary"
                                       onClick={() => {
                                          updateRequest("DECLINED");
                                       }}
                                    >
                                       Stornieren
                                    </Button>
                                    {requestStatus !== "DELIVERED" && (
                                       <Button
                                          type="primary"
                                          onClick={() => {
                                             updateRequest("DELIVERED");
                                          }}
                                       >
                                          Abschließen
                                       </Button>
                                    )}
                                 </div>
                              )}
                           <Button
                              type="default"
                              onClick={() => {
                                 setSelectedRequest(data);
                              }}
                           >
                              Details
                           </Button>
                           <Button
                              type="default"
                              onClick={() => {
                                 setShowRequestComments(true);
                              }}
                           >
                              Chat
                           </Button>
                        </div>
                     )}
                  {requestStatus === "ACCEPTED" && !isPrivateOwner && (
                     <div className="actions">
                        <Button
                           type="default"
                           onClick={() => {
                              setSelectedRequest(data);
                           }}
                        >
                           Details
                        </Button>
                        {!!isPrivateOwner && (
                           <Button
                              type="default"
                              onClick={() => {
                                 setShowRequestComments(true);
                              }}
                           >
                              Chat
                           </Button>
                        )}
                     </div>
                  )}
               </div>
               {!!isPrivateOwner && !!showRequestComments && (
                  <RequestComments
                     data={data}
                     visible={showRequestComments}
                     onClose={() => {
                        setShowRequestComments(!showRequestComments);
                     }}
                     created_by_type="SELLER"
                  />
               )}
            </>
         );
      };

      return (
         <>
            <div
               className={`matching-item ${
                  selling_started !== 0 ? "searching" : "paused"
               }`}
               key={selectedMat.id}
            >
               <div className="matching-state">
                  <div className="sale inner">
                     <div className="matching-state">
                        <div className="search-icon">
                           <PlayCircleOutlined />
                           {/*<LoadingOutlined />*/}
                        </div>
                        <div className="pause-icon">
                           <PauseCircleOutlined />
                        </div>
                        <figure className="demanded">
                           {selectedMat?.images && (
                              <img src={selectedMat?.images[0]?.object_url} />
                           )}
                           {!selectedMat?.images && (
                              <img src="data:image/png;base64,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" />
                           )}
                        </figure>
                     </div>
                     <div className="item-name">
                        <strong>{selectedMat.product_name}</strong>
                        <span className="amount">
                           {selectedMat.amount_op} {selectedMat.amount_unit_op}
                        </span>
                        {/*             {selectedMat?.selling_price && !!isPrivateOwner  && <span className="amount">{selectedMat.selling_price} <b>€/{selectedMat.amount_unit_op}</b></span>}
                         */}
                        {selectedMat?.max_selling_price &&
                           selectedMat?.min_selling_price &&
                           selectedMat?.max_selling_price !==
                              selectedMat?.min_selling_price && (
                              <span className="amount">
                                 {selectedMat.min_selling_price} -{" "}
                                 {selectedMat?.max_selling_price}{" "}
                                 <b>€/{selectedMat.amount_unit_op}</b>
                              </span>
                           )}
                        {selectedMat?.max_selling_price &&
                           selectedMat?.min_selling_price &&
                           selectedMat?.max_selling_price ===
                              selectedMat?.min_selling_price && (
                              <span className="amount">
                                 {selectedMat.min_selling_price}{" "}
                                 <b>€/{selectedMat.amount_unit_op}</b>
                              </span>
                           )}
                     </div>
                     <div className="actions">
                        <Button
                           shape="round"
                           className="more-details"
                           onClick={() => {
                              showDetailPage(selectedMat);
                           }}
                        >
                           {t("selling.details")}
                        </Button>
                        {/* 
                        <Popconfirm
                           title={t("selling.deletePassport.title")}
                           onConfirm={confirmDelete}
                           okText={t("selling.deletePassport.okText")}
                           cancelText={t("selling.deletePassport.cancelText")}
                           okButtonProps={{ loading: deleteLoading }}
                        >
                           <Button type="link">
                              <DeleteOutlined />
                           </Button>
                        </Popconfirm> */}
                     </div>
                  </div>
               </div>
               {requestData.map((rec: any) => (
                  <MatchedData
                     data={rec}
                     getRequestDetails={fetchRequestDetails}
                     setSelectedRequest={(value: any) => {
                        setSelectedRequest(value);
                        setShowRequestDetails(!showRequestDetails);
                     }}
                  />
               ))}
            </div>
            {showPassportDetail && (
               <PassportDetail
                  showRequestBtn={false}
                  visible={showPassportDetail}
                  onClose={onCloseDetail}
                  passportSpecification={passportSpecification}
               />
            )}
            {selectedRequest && (
               <SellingRequestDetails
                  data={selectedRequest}
                  visible={showRequestDetails}
                  onClose={onCloseRequestDetails}
                  passportSpecification={passportSpecification}
               />
            )}
         </>
      );
   };

   const manageSelling = async (status: number) => {
      setManageSellingLoading(true);
      const accessToken = (await Auth.currentSession()).getIdToken();
      await axios
         .get(`${Resource.path.operationsHub}/selling/status/${status}`, {
            headers: { Authorization: accessToken.getJwtToken() }
         })
         .then(() => {
            setManageSellingLoading(false);
            fetchMaterials();
            refetchSelectedMaterials();
            setSellingStatus(status);
         })
         .catch((error) => {
            setManageSellingLoading(false);
            console.log(error);
            message.error(t("buildingOperations.errorMessage"));
         });
   };

   const onCloseDemand = () => {
      setShowAddDemand(false);
   };

   const Demands = (props: any) => {
      const { data, setShowMatches, showMatches, setSelectedMatch } = props;
      const { id, match_count, matches } = data;
      const [requestData, setRequestData] = useState<any>([]);
      const [selectedRequest, setSelectedRequest] = useState<any>({});
      const [showRequestDetails, setShowRequestDetails] =
         useState<boolean>(false);

      const [{ loading: deleteLoading }, removeDemand] = useAxios(
         {
            url: `${Resource.path.operationsHub}/demand/remove/${id}`,
            method: "DELETE"
         },
         { manual: true }
      );

      const [{ loading: getLoading, data: getRequestData }, fetchRequestData] =
         useAxios(
            {
               url: `${Resource.path.getRequestUrlHub(id)}`,
               method: "GET"
            },
            { manual: false }
         );

      const confirmDelete = async () => {
         await removeDemand()
            .then(() => {
               getAllDemands();
               message.success(t("demands.removeDemand.success"));
            })
            .catch((error) => {
               console.log(error);
               message.error(t("buildingOperations.errorMessage"));
            });
      };

      const getMatches = async () => {
         setSelectedMatch(data);
         setShowMatches(!showMatches);
      };

      const onCloseRequestDetails = () => {
         setSelectedRequest({});
         setShowRequestDetails(!showRequestDetails);
      };

      useEffect(() => {
         if (getRequestData?.data) {
            setRequestData(getRequestData.data);
         }
      }, [getRequestData]);

      const MatchesData = (props: any) => {
         const { data, setSelectedRequest, getRequestData } = props;
         const [requestStatus, setRequestStatus] = useState(data.status);
         const [requestPaid] = useState(data.paid);
         const [showRequestComments, setShowRequestComments] =
            useState<boolean>(false);
         const [showOrderDetails, setShowOrderDetails] = useState(false);

         const [{ loading: updateRequestLoading }, updateRequestStatus] =
            useAxios(
               {
                  url: `${Resource.path.updateRequestHub(
                     data.selling_id,
                     data.id
                  )}`,
                  method: "POST"
               },
               { manual: true }
            );

         const [{ loading: deleteRequestLoading }, deleteRequest] = useAxios(
            {
               url: `${Resource.path.removeRequestHub(data.id)}`,
               method: "DELETE"
            },
            { manual: true }
         );

         const updateRequest = async (status: any) => {
            await updateRequestStatus({
               data: {
                  status,
                  comment: "",
                  action_by: "SOURCING"
               }
            })
               .then(() => {
                  setRequestStatus(status);
               })
               .catch((error) => {
                  console.log(error);
               });
         };

         const reqestItemMenu = (
            <Menu>
               <Menu.Item
                  key="1"
                  disabled={!(requestStatus === "REQUESTED")}
                  onClick={async (keys: any) => {
                     await deleteRequest();
                     await getRequestData();
                  }}
               >
                  {t("default.delete")}
               </Menu.Item>
               {!(requestStatus === "REQUESTED") && (
                  <Menu.Item
                     key="2"
                     disabled={
                        requestStatus === "DECLINED" ||
                        requestStatus === "DELIVERED" ||
                        requestStatus === "FAILED" ||
                        requestStatus === "FAILED"
                     }
                     onClick={async (keys: any) => {
                        await updateRequest("DECLINED");
                        await getRequestData();
                     }}
                  >
                     {"Cancel"}
                  </Menu.Item>
               )}
            </Menu>
         );

         if (deleteRequestLoading) {
            (window as any).NProgress.start();
         } else {
            (window as any).NProgress.done();
         }

         return (
            <>
               <div className="request inner sourcing">
                  <div className="matching-state">
                     <figure className="demanded">
                        {data?.images && (
                           <img src={data?.images[0]?.object_url} />
                        )}
                        {!data?.images && (
                           <img src="data:image/png;base64,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" />
                        )}
                     </figure>
                  </div>
                  <div className="item-name">
                     <strong>{data.product_name}</strong>
                     <span className="amount">
                        {data.amount} {data.amount_unit}
                     </span>
                     {data?.selling_price && (
                        <span className="amount">
                           {data.selling_price} <b>€/{data.amount_unit}</b>
                        </span>
                     )}
                     <Button
                        type="primary"
                        className="more-details"
                        onClick={(e) => {
                           setShowOrderDetails(true);
                        }}
                     >
                        {t("demands.orderDetails")}
                     </Button>
                  </div>
                  {requestStatus === "REQUESTED" && (
                     <div className="status">
                        <small>Status</small>
                        <div className="current">
                           <span
                              className={`tag payment ${
                                 requestPaid == 1 ? "paid" : "pending"
                              }`}
                           >
                              {data.proposal_price} €/{data.amount_unit}
                           </span>
                           <span className="tag">angefragt</span>{" "}
                           {!isPrivateOwner && (
                              <span>Auf Verkäufer warten ...</span>
                           )}
                        </div>
                        <div className="progress">
                           <div
                              className={`progress-bar  ${requestStatus.toLowerCase()}`}
                           ></div>
                        </div>
                     </div>
                  )}
                  {requestStatus === "ACCEPTED" && !isPrivateOwner && (
                     <div className="status">
                        <small>Status</small>
                        <div className="current">
                           <span
                              className={`tag payment ${
                                 requestPaid == 1 ? "paid" : "pending"
                              }`}
                           >
                              {data.proposal_price} €/{data.amount_unit}
                           </span>
                           <span className="tag">angenommen</span>{" "}
                           {data?.hubspot_data?.properties?.buyer_update && (
                              <span>
                                 {data.hubspot_data.properties.buyer_update}
                              </span>
                           )}
                        </div>
                        <div className="progress">
                           <div
                              className={`progress-bar  ${requestStatus.toLowerCase()}`}
                           ></div>
                        </div>
                     </div>
                  )}

                  {requestStatus === "ACCEPTED" && !!isPrivateOwner && (
                     <div className="status">
                        <small>Status</small>
                        <div className="current">
                           <span
                              className={`tag payment ${
                                 requestPaid == 1 ? "paid" : "pending"
                              }`}
                           >
                              {data.proposal_price} €/{data.amount_unit}
                           </span>
                           <span className="tag">accepted</span>
                        </div>
                        <div className="progress">
                           <div
                              className={`progress-bar  ${requestStatus.toLowerCase()}`}
                           ></div>
                        </div>
                     </div>
                  )}
                  {requestStatus !== "ACCEPTED" &&
                     requestStatus !== "REQUESTED" &&
                     !isPrivateOwner && (
                        <div className="status">
                           <small>Status</small>
                           <div className="current">
                              <span
                                 className={`tag payment ${
                                    requestPaid == 1 ? "paid" : "pending"
                                 }`}
                              >
                                 {data.proposal_price} €/{data.amount_unit}
                              </span>
                              <span className="tag">
                                 {requestStatus.toLowerCase()}
                              </span>{" "}
                              {data?.hubspot_data?.properties?.buyer_update && (
                                 <span>
                                    {
                                       data.hubspot_data.properties.buyer_update
                                          .value
                                    }
                                 </span>
                              )}
                           </div>
                           <div className="progress">
                              <div
                                 className={`progress-bar  ${requestStatus.toLowerCase()}`}
                              ></div>
                           </div>
                        </div>
                     )}
                  {requestStatus !== "ACCEPTED" &&
                     requestStatus !== "REQUESTED" &&
                     !!isPrivateOwner && (
                        <div className="status">
                           <small>Status</small>
                           <div className="current">
                              <span
                                 className={`tag payment ${
                                    requestPaid == 1 ? "paid" : "pending"
                                 }`}
                              >
                                 {data.proposal_price} €/{data.amount_unit}
                              </span>
                              <span className="tag">
                                 {requestStatus.toLowerCase()}
                              </span>
                           </div>
                           <div className="progress">
                              <div
                                 className={`progress-bar  ${requestStatus.toLowerCase()}`}
                              ></div>
                           </div>
                        </div>
                     )}
                  {requestStatus === "ACCEPTED" && !isPrivateOwner && (
                     <div className="actions">
                        <div className="order">
                           <Button
                              type="primary"
                              onClick={() => {
                                 updateRequest("IN-PROGRESS");
                              }}
                           >
                              Reservieren
                           </Button>
                        </div>
                        {/*<Button type="default" onClick={() => { setSelectedRequest(data) }}>Details</Button>*/}
                        {isPrivateOwner && (
                           <Button
                              type="default"
                              onClick={() => {
                                 setShowRequestComments(true);
                              }}
                           >
                              Chat
                           </Button>
                        )}
                     </div>
                  )}
                  {requestStatus !== "ACCEPTED" &&
                     requestStatus !== "REQUESTED" && (
                        <div className="actions">
                           <Button
                              type="default"
                              onClick={() => {
                                 setSelectedRequest(data);
                              }}
                           >
                              Details
                           </Button>
                           <Dropdown overlay={reqestItemMenu}>
                              <a
                                 className="ant-dropdown-link dotted-menu"
                                 onClick={(e) => e.preventDefault()}
                              >
                                 <EllipsisOutlined />
                              </a>
                           </Dropdown>
                        </div>
                     )}
                  {requestStatus === "REQUESTED" && (
                     <div className="actions">
                        {/*  <Button type="default" onClick={() => { setSelectedRequest(data) }}>Details</Button> */}
                        {isPrivateOwner && (
                           <Button
                              type="default"
                              onClick={() => {
                                 setShowRequestComments(true);
                              }}
                           >
                              Chat
                           </Button>
                        )}

                        <Dropdown overlay={reqestItemMenu}>
                           <a
                              className="ant-dropdown-link dotted-menu"
                              onClick={(e) => e.preventDefault()}
                           >
                              <EllipsisOutlined />
                           </a>
                        </Dropdown>
                     </div>
                  )}
               </div>
               {!!isPrivateOwner && !!showRequestComments && (
                  <RequestComments
                     data={data}
                     visible={showRequestComments}
                     onClose={() => {
                        setShowRequestComments(!showRequestComments);
                     }}
                     created_by_type="BUYER"
                  />
               )}

               {showOrderDetails && (
                  <OrderDetailsModal
                     visible={showOrderDetails}
                     onCancel={() => setShowOrderDetails(false)}
                     requestData={data}
                  />
               )}
            </>
         );
      };

      if (deleteLoading || getLoading) {
         (window as any).NProgress.start();
      } else {
         (window as any).NProgress.done();
      }

      return (
         <>
            <div
               className={`matching-item searching ${
                  match_count && match_count > 0 ? "has-matches" : ""
               }`}
            >
               <div className="demand inner">
                  <div className="matching-state">
                     <div className="search-icon">
                        <SearchOutlined />
                        <LoadingOutlined />
                     </div>
                  </div>
                  <div className="item-name">
                     <strong>
                        {data?.product_group
                           ? data.product_group
                           : data.product_group_id}
                     </strong>
                     <span className="amount">
                        {data.amount} {data.unit}
                     </span>
                     <span className="amount">
                        {data.target_price} <b>€/{data.unit}</b>
                     </span>
                     <Row>
                        <Col span={12}>
                           <Popconfirm
                              title={t("demands.removeDemand.title")}
                              onConfirm={confirmDelete}
                              okText={t("demands.removeDemand.okText")}
                              cancelText={t("demands.removeDemand.cancelText")}
                              okButtonProps={{ loading: deleteLoading }}
                           >
                              <Button type="link">
                                 <DeleteOutlined />
                              </Button>
                           </Popconfirm>
                        </Col>
                     </Row>
                  </div>
                  {!!match_count && match_count > 0 && (
                     <div className="actions">
                        <Button
                           type="primary"
                           className="show-matches"
                           onClick={getMatches}
                        >
                           {match_count} matches
                        </Button>
                     </div>
                  )}
               </div>
               {requestData &&
                  requestData.map((rec: any) => (
                     <MatchesData
                        data={rec}
                        getRequestData={fetchRequestData}
                        setSelectedRequest={(value: any) => {
                           setSelectedRequest(value);
                           setShowRequestDetails(!showRequestDetails);
                        }}
                     />
                  ))}
            </div>
            {showRequestDetails && (
               <SourcingRequestDetails
                  data={selectedRequest}
                  visible={showRequestDetails}
                  onClose={onCloseRequestDetails}
               />
            )}
         </>
      );
   };

   const onCloseMatches = () => {
      setSelectedMatch(null);
      setShowMatches(false);
   };

   if (getDemandsLoading) {
      (window as any).NProgress.start();
   } else {
      (window as any).NProgress.done();
   }

   const onTabChange = (key: any) => {
      getAllDemands();
      callbackInnerTab(key);
   };

   return (
      <Tabs defaultActiveKey={tabKey} onChange={onTabChange}>
         <TabPane tab={t("operations.tabs.selling")} key="1">
            <div className="tab-pane-header">
               <Button
                  type="primary"
                  loading={showDrawerLoading}
                  shape="round"
                  className="add"
                  onClick={showDrawer}
               >
                  {t("selling.btn")}
               </Button>
            </div>
            {selectedMaterials.length === 0 && (
               <div className="matching-action start">
                  <div>
                     <h4>{t("selling.materialPilot.headingIntro")}</h4>
                     <p>{t("selling.materialPilot.messageIntro")}</p>
                  </div>
                  <div>
                     <Button
                        type="primary"
                        loading={showDrawerLoading}
                        shape="round"
                        className="add"
                        onClick={showDrawer}
                     >
                        {t("selling.btn")}
                     </Button>
                  </div>
               </div>
            )}
            {sellingStatus === 0 && selectedMaterials.length > 0 && (
               <div className="matching-action start">
                  <div>
                     <h4>{t("selling.materialPilot.heading")}</h4>
                     <p>{t("selling.materialPilot.message")}</p>
                  </div>
               </div>
            )}
            {sellingStatus !== 0 && (
               <div className="matching-action running">
                  {/*<strong>number of views</strong>*/}
                  <Button
                     type="default"
                     loading={manageSellingLoading}
                     shape="round"
                     icon={<PauseCircleOutlined />}
                     onClick={() => {
                        manageSelling(0);
                     }}
                  >
                     {t("selling.materialPilot.stopBtn")}
                  </Button>
               </div>
            )}
            <div className="matching-list">
               {selectedMaterials.length > 0 &&
                  selectedMaterials.map((selectedMat: any) => (
                     <Passport selectedMat={selectedMat} />
                  ))}
               {selectedMaterials.length === 0 && <Empty />}
            </div>
         </TabPane>

         <TabPane tab={t("operations.tabs.sourcing")} key="2">
            <div className="tab-pane-header">
               <Button
                  type="primary"
                  shape="round"
                  className="add"
                  onClick={() => {
                     addDemand();
                  }}
               >
                  {t("demands.addDemand.btn")}
               </Button>
               {showAddDemand && (
                  <AddDemand
                     visible={showAddDemand}
                     onClose={onCloseDemand}
                     getAllDemands={getAllDemands}
                  ></AddDemand>
               )}
            </div>
            {allDemandsList.length === 0 && (
               <div className="matching-action start">
                  <div>
                     <h4>{t("sourcing.materialPilot.heading")}</h4>
                     <p>{t("sourcing.materialPilot.message")}</p>
                  </div>
                  <Button
                     type="primary"
                     shape="round"
                     className="add"
                     onClick={() => {
                        addDemand();
                     }}
                  >
                     {t("demands.addDemand.btn")}
                  </Button>
               </div>
            )}
            <div className="matching-list">
               {allDemandsList.length > 0 &&
                  allDemandsList.map((demandsList: any) => (
                     <Demands
                        showMatches={showMatches}
                        setShowMatches={setShowMatches}
                        data={demandsList}
                        setSelectedMatch={setSelectedMatch}
                     />
                  ))}
               {allDemandsList.length === 0 && <Empty />}
            </div>
            {selectedMatch && (
               <Matches
                  visible={showMatches}
                  onClose={onCloseMatches}
                  selectedMatch={selectedMatch}
               />
            )}
         </TabPane>
         <TabPane tab={t("operations.tabs.statistics")} key="3">
            <Empty />
         </TabPane>
      </Tabs>
   );
};
